import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Input } from '../../../../../../../components/Form'
import { SearchContainer } from './styles'
import api from 'services/api'
import { apiSearchDishesByType } from '../../../domain/api'

type SearchComponentDishParams = {
  dishTypeId?: number
  dishName: string
  handleSelectDish: (
    id?: number,
    dishName?: string,
    unitMeasure?: string
  ) => void
}

export function SearchComponentDish({
  dishTypeId,
  dishName,
  handleSelectDish
}: SearchComponentDishParams) {
  const [search, setSearch] = useState('')
  const [selected, setSelected] = useState(false)
  const [dishes, setDishes] = useState<IDishData[]>([])

  const getSearched = async (value: string, dishTypeId: number) => {
    if (!dishTypeId) return

    const response = await api.get(
      `${apiSearchDishesByType(String(dishTypeId))}&search=${value}`
    )

    setDishes(response.data)
  }

  const timeOutId = useRef<NodeJS.Timeout>(null)

  const onSearchItem = useCallback(
    async (value: string) => {
      clearTimeout(timeOutId.current)
      timeOutId.current = setTimeout(() => getSearched(value, dishTypeId), 500)
    },
    [dishTypeId]
  )

  useEffect(() => {
    if (dishName) {
      setSearch(dishName)
    }
  }, [dishName])

  return (
    <SearchContainer>
      <div>
        <Input
          label="Item"
          name={'dish_name'}
          id="option"
          onChange={({ target }) => {
            setSearch(target.value)
            setSelected(false)
            onSearchItem(target.value)
          }}
          rules={{ required: true }}
          value={search}
          fullControlled
          onFocus={e => getSearched(e.target.value || '', dishTypeId)}
        />
        <ul>
          {!selected &&
            dishes.map(item => (
              <li
                key={item.id}
                onClick={() => {
                  let unitMeasure = ''
                  if (item.measure) {
                    if (['Pedaco', 'Unidade'].includes(item.measure)) {
                      unitMeasure = 'unit'
                    }
                    if (['Litro', 'Mililitro'].includes(item.measure)) {
                      unitMeasure = 'volume'
                    }
                    if (['Kilo', 'Grama', 'Miligrama'].includes(item.measure)) {
                      unitMeasure = 'weight'
                    }
                  }

                  handleSelectDish(item.id, item.name, unitMeasure)
                  setSearch(item.name)
                  setSelected(true)
                }}
              >
                {item.name}
              </li>
            ))}
        </ul>
      </div>
    </SearchContainer>
  )
}
